export default __webpack_public_path__ + "assets/zip.b8f8ab347fc92f763a2d44617a82b66e.png";